const SUMMARY_TOPIC_SECTION_TITLES = new Set([
  'key topics',
  'decisions',
  'next steps',
  'open questions',
]);

/**
 * Fills empty topic sections in a summary markdown string with a placeholder bullet point.
 *
 * Summaries are structured as `# Title` sections. When a known topic section
 * has no content, this function injects a placeholder so the UI always shows
 * meaningful feedback instead of a blank section.
 *
 * @param markdown - The summary markdown string to process.
 * @param placeholder - The text to inject as a bullet point in empty sections.
 */
export const fillEmptySummaryTopicSections = (
  markdown: string,
  placeholder: string
): string => {
  if (!markdown) {
    return '';
  }

  // Split into sections, keeping the `# ` heading at the start of each chunk
  const sections = markdown.split(/(?=^# )/m);

  return sections
    .map((section) => {
      const match = section.match(/^# (.+?)(?:\n([\s\S]*))?$/);

      if (!match) {
        return section;
      }

      const [, title, content = ''] = match;
      const normalizedTitle = title.trim().toLowerCase();

      // Only fill sections that are known topic sections and have no content
      if (
        SUMMARY_TOPIC_SECTION_TITLES.has(normalizedTitle) &&
        !content.trim()
      ) {
        return `# ${title}\n- ${placeholder}\n`;
      }

      return section;
    })
    .join('');
};